<template>
  <!--公司历史事件轮播-->
  <section
    v-if="dataList.length > 0"
    class="team-section alternate about-auto-container wow fadeInUp animated"
  >
    <div class="auto-container">
      <div class="sec-title with-separator centered">
        <h2>Recruitment Information</h2>
        <!-- <div class="separator">
          <span class="cir c-1"></span><span class="cir c-2"></span><span class="cir c-3"></span>
        </div> -->
        <!--                <div class="lower-text">We are a fully licensed and accredited corporation with extensive industry certifications.-->
        <!--                </div>-->
      </div>
      <div class="team-carousel owl-theme owl-carousel">
        <!--Team Block-->
        <div v-for="item in dataList" :key="item.imgUrl" class="team-block">
          <div class="inner-box">
            <div class="image-box">
              <div :href="item.imgUrl" class="image" data-fancybox="about-gallery">
                <img :src="item.imgUrl" alt="" />
              </div>
              <!--                            <figure class="image"><img :src="item.imgUrl" alt=""></figure>-->
            </div>
            <div class="lower-box">
              <div class="lower_time">{{ item.time }}</div>
              <div class="lower_line">
                <span class="lower_line_dot"></span>
                <div class="lower_line_line"></div>
              </div>
              <h4>
                <router-link :to="item.path">{{ item.title }}</router-link>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/index.js'
export default {
  name: 'recruitmentText',
  data() {
    return {
      loading: false,
      Page: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
        orders: [],
      },
      dataList: [],
    }
  },
  created() {},
  mounted() {
    // this.refreshList()
  },
  methods: {
    refreshList(data) {
      this.loading = true
      if (data) {
        this.dataList = data.page.list.map((item) => {
          return {
            imgUrl: item.image, // item.document,//
            title: item.title,
            time: this.moment(item.releaseDate).format('YYYY-MM-DD'),
            id: item.id,
            type: 'recruitment',
            detailtype: 'recruitment',
            path: '/details/' + item.id,
          }
        })
        this.Page.total = data.page.count
        this.$nextTick(() => {
        this.loading = false
        this.carousel()
        })
      } else {
        api
          .webList({
            pageNo: this.Page.currentPage,
            pageSize: this.Page.pageSize,
            isPublished: '1', //是发布的
            columnName: 'recruitment', //是招聘列表
          })
          .then((res) => {
            this.dataList = res.page.list.map((item) => {
              return {
                imgUrl: item.image, // item.document,//
                title: item.title,
                time: this.moment(item.releaseDate).format('YYYY-MM-DD'),
                id: item.id,
                type: 'recruitment',
                detailtype: 'recruitment',
                path: '/details/' + item.id,
              }
            })
            this.Page.total = res.page.count
          })
          .finally(() => {
            this.loading = false
            this.carousel()
          })
      }
    },
    carousel() {
      //公司事件轮播
      if ($('.team-carousel').length) {
        $('.team-carousel').owlCarousel({
          loop: true,
          margin: 10,
          nav: true,
          smartSpeed: 500,
          autoplay: 5000,
          autoplayTimeout: 5000,
          navText: [
            '<span class="icon flaticon-back"></span>',
            '<span class="icon flaticon-next"></span>',
          ],
          responsive: {
            0: {
              items: 1,
            },
            600: {
              items: 2,
            },
            768: {
              items: 3,
            },
            1024: {
              items: 3,
            },
            1200: {
              items: 4,
            },
          },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
